import { render, staticRenderFns } from "./AvatarBadge.vue?vue&type=template&id=2b27cbd9&scoped=true&"
import script from "./AvatarBadge.vue?vue&type=script&setup=true&lang=js&"
export * from "./AvatarBadge.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AvatarBadge.vue?vue&type=style&index=0&id=2b27cbd9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b27cbd9",
  null
  
)

export default component.exports